import classNames from "classnames";
import styles from "../Editor.module.scss";

const HeaderBlock = ({text, level = 2}) => {
    // защита от кривых данных
    const safeLevel = Math.min(Math.max(level, 2), 6);
    const Tag = `h${safeLevel}`;

    return (
        <Tag className={classNames(styles.reHeader, styles[`reHeaderH${safeLevel}`])}>{text}</Tag>
    );
};

export default HeaderBlock;
